import { Switch } from '@/components/ui/switch';

interface ActiveOnlySwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: string;
}

const ActiveOnlySwitch = ({ checked, onChange, label = 'nur die Aktiven' }: ActiveOnlySwitchProps) => (
    <Switch
        id='active-only'
        colorPalette='blue'
        checked={checked}
        onCheckedChange={event => onChange(event.checked)}
    >
        {label}
    </Switch>
);

export default ActiveOnlySwitch;
